import {type Set} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';

import type * as Models from './models';
import {type SortOrder} from './constants';

const domain = 'LISTS_RESULTS';

export const {
    action: fetchResults,
    success: fetchResultsSuccess,
    failed: fetchResultsFailed,
} = createAction(
    `${domain}_FETCH_RESULTS`,
    (payload: {fetchMore?: boolean; offset?: number; columnsFromQueryParams?: Set<string>}) => payload,
    (results: typeof Models.Results.default, fetchMore?: boolean) => ({results, fetchMore}),
);

export const {action: fetchResultsDebounced} = createAction(
    `${domain}_FETCH_RESULTS_DEBOUNCED`,
    (payload: {fetchMore?: boolean; offset?: number; columnsFromQueryParams?: Set<string>}) => payload,
);

export const {action: setOffset} = createAction(`${domain}_SET_OFFSET`, (payload: {offset: number}) => payload);

export const {action: changeSortBy} = createAction(
    `${domain}_CHANGE_SORT_BY`,
    (payload: {sortBy: string; sortOrderOverwrite?: SortOrder; columnsFromQueryParams?: Set<string>}) => payload,
);

export const {action: setSortBy} = createAction(
    `${domain}_SET_SORT_BY`,
    (sortBy: string, sortOrderOverwrite?: SortOrder) => ({
        sortBy,
        sortOrderOverwrite,
    }),
);

export const {action: reset} = createAction(`${domain}_RESET`, () => ({}));
